import type { Epic } from '../../index.js'
import { catchError, filter, map, switchMap } from 'rxjs/operators'
import { of } from 'rxjs'
import { projectSlice } from '../../Slice/Project/ProjectSlice.js'

export const AcceptProjectInviteEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) => {
  return action$.pipe(
    filter(project.acceptProjectInviteRequest.match),
    switchMap((action) => {
      const { projectId, inviteId } = action.payload
      return ProjectRepository.acceptProjectInvite(projectId, inviteId).pipe(
        map((invite) => projectSlice.actions.acceptProjectInviteRequestSuccess(invite)),
        catchError((error) => of(projectSlice.actions.acceptProjectInviteRequestFailure({ error })))
      )
    })
  )
}
